import "../PageCommon.css";
import "./UserGuide.css";

const UserGuidePage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <h2>User Guide</h2>
        </div>
      </div>
    </div>
  );
}

export default UserGuidePage;